export function isValidApiKey (apikey: string | null | undefined) {
  if (!apikey) {
    return false
  }
  const normalized = apikey.toLowerCase()
  return normalized !== 'null' && normalized !== 'undefined'
}

export function isBetterAuthApiKey (apikey: string | null | undefined) {
  return isValidApiKey(apikey) && String(apikey).startsWith('betterauth:')
}

export function isAuthStatusError (error: any) {
  const status = error?.response?.status ?? error?.statusCode ?? error?.status
  // 403 stays here: the backend's expired-session check also throws 403.
  return status === 401 || status === 403
}

export function isJohkuBackendRequest (
  url: string,
  baseDomain: string,
  serviceDomain?: string
) {
  if (!url) {
    return false
  }
  if (url.startsWith('/api/')) {
    return false
  }
  if (url.startsWith('http')) {
    if (baseDomain && url.startsWith(baseDomain)) {
      return true
    }
    if (serviceDomain && url.startsWith(serviceDomain)) {
      return true
    }
    return false
  }
  return !url.startsWith('/api/')
}

export function resolveJohkuRequestUrl (url: string, baseURL?: string) {
  if (url.startsWith('http')) {
    return url
  }
  if (baseURL) {
    return baseURL.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
  }
  return url
}

// Avoids `new Headers(...)`, which can corrupt AxiosHeaders into a phantom "0" header.
export function headersToPlainObject (headers?: Record<string, string> | Headers | null): Record<string, string> {
  const result: Record<string, string> = {}
  if (!headers) {
    return result
  }
  const maybeHeaders = headers as Headers
  if (typeof maybeHeaders.forEach === 'function' && typeof maybeHeaders.entries === 'function') {
    // Native Headers instance
    maybeHeaders.forEach((value, key) => {
      result[key] = value
    })
    return result
  }
  // Plain object or AxiosHeaders (which stores each header as an own
  // enumerable, already-normalized property on the instance itself)
  Object.assign(result, headers)
  return result
}

export function authHeadersForJohkuRequest (
  apiKey: string | null | undefined,
  existingHeaders?: Record<string, string> | Headers
): Record<string, string> | Headers | undefined {
  if (!isValidApiKey(apiKey)) {
    return existingHeaders
  }
  const headers = headersToPlainObject(existingHeaders)
  const hasAuthorization = Object.keys(headers).some((key) => key.toLowerCase() === 'authorization')
  if (!hasAuthorization) {
    headers.Authorization = 'Bearer ' + apiKey
  }
  return headers
}
